import PropTypes from 'prop-types';
import FallingPetalsCSS from './FallingPetalsCSS';
import FallingPetalsCanvas from './FallingPetalsCanvas';
import FallingPetalsThree from './FallingPetalsThree';
import FallingPetalsImage from './FallingPetalsImage';
import FallingLotusModel3D from './FallingLotusModel3D';
import FallingLotusPhoto from './FallingLotusPhoto';
import FallingWindPhoto from './FallingWindPhoto';

const ENGINES = {
    css: FallingPetalsCSS,
    canvas: FallingPetalsCanvas,
    three: FallingPetalsThree,
    image: FallingPetalsImage,
    model3d: FallingLotusModel3D,
    photo: FallingLotusPhoto,
    wind: FallingWindPhoto,
};

/**
 * 飄落蓮花 / 菩提葉特效 - 統一入口
 * Falling lotus flowers / bodhi leaves - unified entry point
 *
 * 用法：<FallingPetals engine="model3d" chance={0.5} />
 * chance < 1 時，依機率決定該次掛載是否顯示特效（例如某些頁面只想有機率飄落）。
 *
 * engine="model3d" 是真正的立體 3D 模型（Three.js 幾何體，非平面貼圖），任何角度
 * 旋轉都正確，僅支援蓮花。engine="image" 使用成熟美術素材（CC0 授權，取自
 * freesvg.org）。engine="photo" 是單張寫實照片素材、沿固定拋物線路徑飄落（需傳入
 * imageSrc）。engine="wind" 同樣用寫實照片素材，但改用 requestAnimationFrame
 * 即時模擬風力（非預先算好的固定路徑），效果更隨機自然，參考 Sarah Higley 的
 * "Falling Leaves" 演算法。css/canvas/three 三個引擎則是程式繪製或十字交叉貼圖的花朵。
 */
const FallingPetals = ({ engine = 'model3d', chance = 1, ...props }) => {
    const Engine = ENGINES[engine] ?? ENGINES.model3d;

    // chance 為每次「掛載」時的顯示機率；用 lazy state 確保同一次掛載不會中途變化
    const shouldRender = chance >= 1 || Math.random() < chance;
    if (!shouldRender) return null;

    return <Engine {...props} />;
};

FallingPetals.propTypes = {
    engine: PropTypes.oneOf(['css', 'canvas', 'three', 'image', 'model3d', 'photo', 'wind']),
    chance: PropTypes.number,
    type: PropTypes.oneOf(['lotus', 'bodhi']),
    variant: PropTypes.oneOf(['silhouette', 'gradient', 'mandala']),
    imageSrc: PropTypes.string,
    count: PropTypes.number,
    color: PropTypes.string,
    className: PropTypes.string,
};

export default FallingPetals;
export { FallingPetalsCSS, FallingPetalsCanvas, FallingPetalsThree, FallingPetalsImage, FallingLotusModel3D, FallingLotusPhoto, FallingWindPhoto };
